import { render, staticRenderFns } from "./CapNhatNguoiDung.vue?vue&type=template&id=36c3bb5e&"
import script from "./CapNhatNguoiDung.vue?vue&type=script&lang=js&"
export * from "./CapNhatNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports